import { Component } from '@angular/core';
import { ComprasService } from '../../service/compras/compras.service';

@Component({
  selector: 'app-listado-anticipos',
  standalone: true,
  imports: [],
  templateUrl: './listado-anticipos.component.html',
  styleUrl: './listado-anticipos.component.scss'
})
export class ListadoAnticiposComponent {

  anticiposList: any[] = [];

  constructor(
    private comprasService: ComprasService
  ){
    this.getData();
  }

  getData(){

    const body = {
      proveedorId: null,
      ordenCompraId: null,
      estatusAnticipoId: 1,
      pageNumber: 1,
      pageSize: 10
    }

    this.comprasService.listadoAnticipos(body).subscribe((data) => {

      if(data){
        this.anticiposList = data;
        console.log('data: ',this.anticiposList);
      }
    },error => {

    });
  }
  
}
